module.exports = __webpack_public_path__ + "img/80a653f6-7f00-457e-859e-376449ee0e6a.a6eaa860.png";